import { getVoteViewState } from './VoteViewState.ts';
export function shouldRejectVoteOnClose(voteState, viewerColor) {
    const voteViewState = getVoteViewState(voteState, viewerColor);
    const isVoter = voteViewState.role == 'voter';
    const isPending = voteViewState.viewerVoteResponse == 'pending';
    return isVoter && isPending;
}
